'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'heart-pulse';
var width = 512;
var height = 512;
var aliases = ["heartbeat"];
var unicode = 'f21e';
var svgPathData = 'M378.9 80c-27.3 0-53 13.1-69 35.2l-34.4 47.6c-4.5 6.2-11.7 9.9-19.4 9.9s-14.9-3.7-19.4-9.9l-34.4-47.6c-16-22.1-41.7-35.2-69-35.2-47 0-85.1 38.1-85.1 85.1 0 31.1 12.4 61.6 30.5 90.9l44.9 0c3.1 0 6-1.8 7.3-4.7l31.5-69.2c3.8-8.3 12-13.8 21.1-14.1s17.7 4.7 21.9 12.8l52.4 98.9 42-68.2c4.4-7.2 12.4-11.6 20.8-11.4s16.2 4.7 20.4 12.1L363.6 252c1.4 2.5 4.1 4 6.9 4l62.9 0c18.1-29.2 30.5-59.8 30.5-90.9 0-47-38.1-85.1-85.1-85.1zM440 304l-69.4 0c-20.1 0-38.6-10.8-48.6-28.2l-2.7-4.7-42.8 69.5c-4.5 7.3-12.6 11.7-21.2 11.4s-16.4-5.1-20.4-12.8l-49.1-92.8-11.3 24.8c-9.1 20-29 32.8-51 32.8l-70.6 0C25 264.9 0 217.4 0 165.1 0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1 512 217.4 487 264.9 459.2 304L440 304zM91 352l65.5 0c30.6 31.1 61.9 57.6 85.6 75.8 3.2 2.4 7.9 4.2 14 4.2s10.8-1.8 14-4.2c23.7-18.1 55-44.7 85.6-75.8l65.5 0c-41.5 47.6-88.7 88.5-121.9 113.9-12.3 9.4-27.5 14.1-43.1 14.1s-30.8-4.7-43.1-14.1C179.6 440.5 132.5 399.6 91 352z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeartPulse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;